export const sliceNames = {
    authentication: 'authentication',
    form: 'form',
    questions: 'questions',
    submissionPeriod: 'submissionPeriod',
    storage: 'storage',
    common: 'common',
    alert: 'alert',
}